<div
  [style]="{
    width: width() ? width() + 'px' : '100%',
    height: height() ? height() + 'px' : '100%',
  }"
  class="bg-gray-300 animate-pulse rounded-xl"
></div>
